import { loadConfig } from '@ordernext/networking-stadium/stadium/actions'
import { isEmpty } from 'lodash'
import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { useHistory } from 'react-router-dom'
import VNLoader from '../VNLoader/components/VNLoader'
import { getShouldWaitForRedirect } from '../selectors/config'
import { getIsKiosk } from '../selectors/menus'

const useCheckConfig = () => {
  const [showSpinner, setShowSpinner] = useState(false)
  const state = useStore().getState()
  const dispatch = useDispatch()
  const isKiosk = getIsKiosk(state)
  const shouldRefreshConfig = useMemo(() => state?.config?.shouldRefreshConfig ?? true, [state?.config?.shouldRefreshConfig])
  const shouldWaitForRedirect = useSelector(getShouldWaitForRedirect)
  const { location, replace } = useHistory()
  const blackListPaths = ['/', '/device-login', '/revenue-center-setup', '/register-device']
  const redirectPath = useMemo(() => {
    const pathname = location?.pathname ?? '/'
    const search = location?.search ?? ''
    const hash = location?.hash ?? ''
    return `${pathname}${search}${hash}`
  }, [location])

  useEffect(() => {
    if (!shouldRefreshConfig || !shouldWaitForRedirect) {
      setShowSpinner(false)
    }
  }, [shouldRefreshConfig, shouldWaitForRedirect])

  useEffect(() => {
    if (!localStorage.getItem('accessToken') || isEmpty(state)) {
      replace('/device-login')
      return
    }

    if (shouldRefreshConfig && !blackListPaths.includes(redirectPath)) {
      dispatch(loadConfig())
      setShowSpinner(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (showSpinner) {
    return <VNLoader isKiosk={isKiosk} />
  }
}

export default useCheckConfig
